'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroTabs = require('./NitroTabs');

var _NitroTabs2 = _interopRequireDefault(_NitroTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroTabs2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-tabs/index.js
// module id = 182
// module chunks = 4